/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type categoriesSection_query$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type categoryListPage_query$ref: FragmentReference;
export type categoryListPage_query = {|
  +playbook: {|
    +headerPicture: string,
    +seo: ?{|
      +title: ?string,
      +description: ?string,
    |},
    +social: ?{|
      +twitter: ?$ReadOnlyArray<?{|
        +type: ?string,
        +title: ?string,
        +image: ?string,
        +handle: ?string,
        +description: ?string,
      |}>,
      +generic: ?$ReadOnlyArray<?{|
        +title: ?string,
        +image: ?string,
        +description: ?string,
      |}>,
    |},
  |},
  +$fragmentRefs: categoriesSection_query$ref,
  +$refType: categoryListPage_query$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "image",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "categoryListPage_query",
  "type": "Query",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "playbook",
      "storageKey": null,
      "args": null,
      "concreteType": "Playbook",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "headerPicture",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "seo",
          "storageKey": null,
          "args": null,
          "concreteType": "SEO",
          "plural": false,
          "selections": [
            v0,
            v1
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "social",
          "storageKey": null,
          "args": null,
          "concreteType": "SocialMedia",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "twitter",
              "storageKey": null,
              "args": null,
              "concreteType": "TwtrSlices",
              "plural": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "type",
                  "args": null,
                  "storageKey": null
                },
                v0,
                v2,
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "handle",
                  "args": null,
                  "storageKey": null
                },
                v1
              ]
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "generic",
              "storageKey": null,
              "args": null,
              "concreteType": "GenSocialSlices",
              "plural": true,
              "selections": [
                v0,
                v2,
                v1
              ]
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "categoriesSection_query",
      "args": null
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f071462c6f8bec50f71c23bff55d73b7';
module.exports = node;
